module.exports = __webpack_public_path__ + "img/zoomOut.c2235c2d.png";